import { ABOUT } from "@/content";

export const About = () => (
  <section className="intro" id="sobre" data-testid="about-section">
    <div className="wrap intro-grid">
      <div className="intro-visual">
        <img src={ABOUT.image.src} alt={ABOUT.image.alt} />
      </div>
      <div>
        <p className="eyebrow">{ABOUT.eyebrow}</p>
        <h2>{ABOUT.title}</h2>
        {ABOUT.paragraphs.map((paragraph) => (
          <p key={paragraph}>{paragraph}</p>
        ))}
        <p className="signature">{ABOUT.signature}</p>
        <a className="text-link" href={ABOUT.link.href} data-testid="about-link-doulagem">
          {ABOUT.link.label}
        </a>
      </div>
    </div>
  </section>
);
